import React, { useEffect, useState } from "react";
import DashboardLayout from "@/components/DashboardLayout";
import StatCard from "@/components/StatCard";
import api from "@/lib/api";
import { LayoutDashboard, School as SchoolIcon, Store, Users, Package, ShoppingBag, TrendingUp, Inbox, Wallet, Settings as SettingsIcon, BookMarked, FileSpreadsheet } from "lucide-react";

const NAV = [
  { to: "/super/dashboard", label: "Overview", icon: LayoutDashboard },
  { to: "/super/schools", label: "Schools", icon: SchoolIcon },
  { to: "/super/products", label: "Products", icon: Package },
  { to: "/super/book-kits", label: "Book Kits", icon: BookMarked },
  { to: "/super/vendors", label: "Vendors", icon: Store },
  { to: "/super/orders", label: "Orders & Ops", icon: ShoppingBag },
  { to: "/super/school-rfqs", label: "School RFQs", icon: FileSpreadsheet },
  { to: "/super/finance", label: "Finance", icon: Wallet },
  { to: "/super/enquiries", label: "Enquiries", icon: Inbox },
  { to: "/super/settings", label: "Settings", icon: SettingsIcon },
];
export { NAV as SUPER_NAV };

export default function SuperDashboard() {
  const [data, setData] = useState(null);
  const [schools, setSchools] = useState([]);
  useEffect(() => {
    Promise.all([api.get("/dashboard/super"), api.get("/schools")]).then(([d, s]) => { setData(d.data); setSchools(s.data); });
  }, []);
  return (
    <DashboardLayout nav={NAV} title="Super Admin Console">
      {data && (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-6">
          <StatCard label="Schools" value={data.schools} icon={SchoolIcon} tone="blue" testid="s-schools" />
          <StatCard label="Vendors" value={data.vendors} icon={Store} tone="green" testid="s-vendors" />
          <StatCard label="Parents" value={data.parents} icon={Users} tone="slate" testid="s-parents" />
          <StatCard label="Products" value={data.products} icon={Package} tone="amber" testid="s-products" />
          <StatCard label="Orders" value={data.orders} icon={ShoppingBag} tone="blue" testid="s-orders" />
          <StatCard label="Purchase Orders" value={data.purchase_orders} icon={TrendingUp} tone="green" testid="s-pos" />
        </div>
      )}
      <div className="sl-card p-5">
        <h3 className="font-heading font-semibold mb-3">Registered schools</h3>
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-600"><tr><th className="text-left px-3 py-2">Name</th><th className="text-left px-3 py-2">City</th><th className="text-left px-3 py-2">Board</th><th className="text-right px-3 py-2">Annual Budget</th></tr></thead>
          <tbody>
            {schools.map((s) => (
              <tr key={s.id} className="border-t border-slate-100">
                <td className="px-3 py-2 font-semibold text-slate-800">{s.name}</td>
                <td className="px-3 py-2 text-slate-600">{s.city || "—"}</td>
                <td className="px-3 py-2 text-slate-600">{s.board || "—"}</td>
                <td className="px-3 py-2 text-right">₹{Number(s.annual_budget || 0).toLocaleString('en-IN')}</td>
              </tr>
            ))}
            {schools.length === 0 && <tr><td colSpan={4} className="text-center py-8 text-slate-500">No schools yet</td></tr>}
          </tbody>
        </table>
      </div>
    </DashboardLayout>
  );
}
